import { createFileRoute } from "@tanstack/react-router";

import { CampaignWizard } from "../features/campaigns/CampaignWizard";

export const Route = createFileRoute("/app/campaigns/new")({
  component: CampaignWizard,
});
